import {
  Logger,



} from '@mindpath/shared';

import {DateTime} from "luxon";
//
// @Injectable({
//   providedIn: 'root'
// })
// export class OnlineSchedulerService {
//
//   piwik = inject(PiwikService);
//
//
//   #uiSvc = inject(UiService);
//   showLoading = this.#uiSvc.showLoading.bind(this.#uiSvc);
//   hideLoading = this.#uiSvc.hideLoading.bind(this.#uiSvc);
//   showError = this.#uiSvc.showError.bind(this.#uiSvc);
//   dimming = this.#uiSvc.dimming;
//   sidebar = this.#uiSvc.sidebar;
//
//
// }

 
export function NaiveDateDeserializer<T extends Record<string, unknown> | Record<string, unknown>[]>(obj: T): T {
  if (Array.isArray(obj)) {
    return obj.map(NaiveDateDeserializer) as unknown as T;
  }

  for (const key in obj) {
    // console.log('Checking', key, obj[key]);
    if (key.toString().startsWith('date') || key.toLowerCase() === 'dob' ||
      key.toLowerCase().includes('expiresat') || key.toLowerCase().includes('expireson')) {
      const val = (obj as unknown as Record<string, unknown>)[key];
      if (!val) continue;
      if (val instanceof DateTime) {
        continue;
      }
      let date: DateTime | undefined;
      // check if all digits
      if (typeof val === 'string' && val.match(/^\d+$/)) {
        const num = parseInt(val);
        if (num > 0) {
          date = DateTime.fromMillis(num);
        }
      } else {
        date = DateTime.fromISO(val as string, {setZone: true});
      }

      if (date?.isValid) {
        (obj as unknown as Record<string, unknown>)[key] = date;
        continue;
      }

      Logger.Warn('OnlineScheduler', 'Skipping possibly invalid date', (obj as unknown as Record<string, unknown> )[key]);

    }
    const val = (obj as unknown as Record<string, unknown>)[key];
    if (typeof val !== 'object') {
      continue;
    }
    NaiveDateDeserializer(val as Record<string, unknown>);
  }
  return obj;
}


// type FlattenObjectKeysOrig<T, Key = keyof T> =
//   Key extends string ? T[Key] extends Record<string, unknown> ? `${Key}.${FlattenObjectKeys<T[Key]>}` : Key : never;
// type FlattenObjectKeys<T, Key = keyof T> =
//   T extends Signal<infer U> ? FlattenObjectKeys<U> :
//     Key extends string ? T[Key] extends Record<string, unknown> | null ? `${Key}.${FlattenObjectKeys<T[Key]>}` : Key : never;


// `Invalid path: ${(T extends string ? T : '$')} ${P}`;


